import React from 'react';

interface NewsletterSubscriptionProps {
  title?: string;
  description?: string;
  placeholder?: string;
  buttonText?: string;
  className?: string;
}

const NewsletterSubscription: React.FC<NewsletterSubscriptionProps> = ({
  title = "Get the latest Digi Cartt updates",
  description = "Subscribe for product releases, marketplace tips, and exclusive offers—straight to the inbox.",
  placeholder = "Enter your email",
  buttonText = "Submit Email",
  className = ""
}) => {
  // Removed unused variables: email, isSubmitting, message, handleSubmit

  return (
    <section className="contact_section">
    <div className="contact_sec">
      <div className="container">
        <div className="contact_area color_lightwhite">
          <div className="row align-items-center">
            <div className="col-lg-6">
              <div className="contact_area_info d-flex flex-column">
                <div className="contact_info_title_area d-flex flex-column text-lg-start text-center justify-content-lg-start justify-content-center">
                  <h2 className="heading_text_2">
                    Get the latest Digi Cartt updates
                  </h2>
                  <p className="font_two">
                    Subscribe for product releases, marketplace tips, and
                    exclusive offers—straight to the inbox.
                  </p>
                </div>
                <form action="#" className="contact_area_form">
                  <div className="contact_area_form_box position-relative">
                    <input
                      type="email"
                      placeholder="Enter your email"
                      required
                    />
                    <button type="submit" className="btn btn-dark primary-btn blue_btn">
                    {/* btn btn-dark primary-btn w-50 rounded-pill */}
                      Submit Email
                    </button>
                  </div>
                </form>
              </div>
            </div>
            <div className="col-lg-6 d-lg-flex d-none">
              <div className="contact_img_area_info">
                <div className="contact_img_area">
                  <img
                    src="/assets/images/contact_sec_img_1.png"
                    alt="contact_sec_img"
                  />
                  <img
                    src="/assets/images/contact_sec_img_2.png"
                    alt="contact_sec_img"
                  />
                </div>
                <div className="contact_img_area">
                  <img
                    src="/assets/images/contact_sec_img_3.png"
                    alt="contact_sec_img"
                  />
                  <img
                    src="/assets/images/contact_sec_img_4.png"
                    alt="contact_sec_img"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
  );
};

export default NewsletterSubscription;


